export default {
  name: 'Control Tower 管理系统',
  description: '企业级后台管理系统',
  welcome: '欢迎使用'
}
